const config = {
  baseUrl: String((window as any).BASE_URL),
  widgetHost: String((window as any).WIDGET_HOST),
  authWebUrl: String((window as any).AUTH_WEB_URL),
  authApiUrl: String((window as any).AUTH_API_URL),
  apiUrl: String((window as any).DM_API_URL),
};

export default config;
